import { GET_DMX_DEVICE_BY_ID, GET_DMX_DEVICE_BY_ID_SUCCESS, GET_DMX_DEVICE_BY_ID_ERROR } from './actionTypes';

export const getDmxDeviceById = (user, deviceId) => {
  return {
    type: GET_DMX_DEVICE_BY_ID,
    payload: { user, deviceId },
  };
};

export const getDmxDeviceByIdSuccess = (device) => {
  return {
    type: GET_DMX_DEVICE_BY_ID_SUCCESS,
    payload: { device },
  };
};

export const getDmxDeviceByIdError = (error) => {
  return {
    type: GET_DMX_DEVICE_BY_ID_ERROR,
    payload: error,
  };
};
